const quickViewWarpper = document.getElementById("quickViewWrapper");

// Add helper function
const isMobileOrTablet = () => window.innerWidth <= 1024;
const isDesktop = () => window.innerWidth > 1024;

class quickViewModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClickQuickViewModal);

    quickViewWarpper.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") {
        this.closeModal();
      }
    });

    document.addEventListener("click", (event) => {
      let eventTarget = event.target;
      // Check if modal is open and click is outside
      if (quickViewWarpper.classList.contains("show__modal") && 
          !eventTarget.closest(".quick_view__body") && 
          !eventTarget.closest("quick-view-modal")) {
        this.closeModal();
      }
    });
  }

  closeModal() {
    const activeButton = document.querySelector("quick-view-modal button.active");
    
    // Add closing animation for both desktop and mobile/tablet
    quickViewWarpper.classList.add("closing");
    
    // Different timing for desktop vs mobile/tablet
    const animationDuration = isDesktop() ? 400 : 550;
    
    setTimeout(() => {
      quickViewWarpper.classList.remove("show__modal", "closing");
      document.body.classList.remove("modal-open");
      if (activeButton) {
        removeTrapFocus(activeButton);
        activeButton.classList.remove("active");
      }
    }, animationDuration);
  }
  
  onClickQuickViewModal = async () => {
    let quickViewModal = this.querySelector("button");
    let productHandle = quickViewModal.dataset.productHandle;
    quickViewModal.classList.add("loading");
    
    try {
      const response = await fetch(`/products/${productHandle}?view=quickview`);
      const resText = await response.text();
      quickViewWarpper.innerHTML = resText;

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      document.body.classList.add("modal-open");
      quickViewWarpper.classList.add("show__modal");
      quickViewModal.classList.add("active");
      
      // Update pre-sale badge when quick view opens
      setTimeout(() => {
        updateQuickViewPreSaleBadge();
      }, 100);
      
    } catch (error) {
      console.log("error", error);
    } finally {
      quickViewModal.classList.remove("loading");
      trapFocus(quickViewWarpper);
    }
  };
}
customElements.define("quick-view-modal", quickViewModal);

class quickViewCloseTag extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.quickViewClose);
    this.currentVariant = {};
  }

  quickViewClose() {
    // Add closing animation for both desktop and mobile/tablet
    quickViewWarpper.classList.add("closing");
    
    // Different timing for desktop vs mobile/tablet
    const animationDuration = isDesktop() ? 400 : 550;
    
    setTimeout(() => {
      quickViewWarpper.classList.remove("show__modal", "closing");
      document.body.classList.remove("modal-open");
    }, animationDuration);
  }
}
customElements.define("quick-view-close", quickViewCloseTag);

class QuickVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.getPreOrderVariantData();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll(".product-form__input--dropdown")).map(
      (select, index) => {
        select.children[0].children[1].innerHTML = this.options[index];
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        //console.log(destination);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("no-js-inline");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }
toggleAddButton(disable = true, text, modifyClass = true) {
  const productForm = document.getElementById(
    `product-form-${this.dataset.section}`
  );
  if (!productForm) return;
  const addButton = productForm.querySelector('[name="add"]');
  const buttonPrice = productForm.querySelector('[data-button-price]');
  const buttonText = addButton ? addButton.querySelector('.button-text') : null;

  if (!addButton) return;
  
  // Update button disabled state and text
  if (disable) {
    addButton.setAttribute("disabled", true);
    if (text && buttonText) buttonText.textContent = text;
  } else {
    addButton.removeAttribute("disabled");
    if (buttonText) buttonText.textContent = window.variantStrings.addToCart;
  }

  // Update button price
  if (buttonPrice && this.currentVariant) {
    const price = this.currentVariant.price;
    const formattedPrice = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(price / 100);
    buttonPrice.textContent = formattedPrice;
  }

  // Preorder Button Logic
  let productVarArray = this.PreorderVariantData;
  let variant = this.currentVariant;
  let VarInventoryManagement =
    this.currentVariant?.inventory_management ?? null;
  let var_num = "";
  
  if (VarInventoryManagement != null) {
    for (let variant_id in productVarArray) {
      if (variant.id == variant_id) {
        var_num = productVarArray[variant_id].qty;
        var inventoryQuantity = parseInt(var_num);
        var inventoryPolicy = productVarArray[variant_id].inventory_policy;
      }
      if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
        addButton.removeAttribute("disabled");
        if (buttonText) buttonText.textContent = window.variantStrings.preorder;
      } else if (inventoryQuantity <= 0 && inventoryPolicy !== "continue") {
        addButton.setAttribute("disabled", true);
        if (buttonText) buttonText.textContent = window.variantStrings.soldOut;
      } else {
        addButton.removeAttribute("disabled");
        if (buttonText) buttonText.textContent = window.variantStrings.addToCart;
      }
    }
  }
  
  if (!modifyClass) return;
}

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant]").textContent);
    return this.variantData;
  }
  getPreOrderVariantData() {
    this.PreorderVariantData =
      this.PreorderVariantData ||
      JSON.parse(this.querySelector("[data-preorder]").textContent);
  }
}

customElements.define("quick-variant-selects", QuickVariantSelects);

class QuickVariantRadios extends QuickVariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.onColorSwatches();
  }

  onColorSwatches() {
    const swatchButtonList = this.querySelectorAll(
      `fieldset.variant--swatch-${this.dataset.colorSwatch} > label`
    );
    const result = Object.values(
      this.getVariantData().reduce((total, item) => {
        let k = `${item[this.dataset.colorSwatch]}`;
        if (!total[k]) {
          total[k] = { ...item, count: 1 };
        } else {
          total[k].count += 1;
        }
        return total;
      }, {})
    );
    swatchButtonList.forEach((button) => {
      result.forEach((data) => {
        if (data[this.dataset.colorSwatch] === button.dataset.value) {
          if (
            this.dataset.colorSwatchStyle === "image" &&
            data.featured_image !== null
          ) {
            button.setAttribute(
              "style",
              `--swatch-background-image: url(${
                data.featured_image.src
              }); --swatch-background-color: ${data[this.dataset.colorSwatch]};`
            );
          } else {
            button.setAttribute(
              "style",
              `--swatch-background-color: ${data[this.dataset.colorSwatch]};`
            );
          }
        }
      });
    });
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateOptionsParent() {
    this.fieldsets.map((fieldset, index) => {
      fieldset.children[0].children[1].innerHTML = this.options[index];
    });
  }
}
customElements.define("quick-variant-radios", QuickVariantRadios);

// =============================================
// PRE-SALE BADGE FUNCTIONALITY
// =============================================
function updateQuickViewPreSaleBadge() {
  const badge = document.querySelector('.quick_view__body .pre-sale-badge-container-quickview');
  const quickViewBody = document.querySelector('.quick_view__body');
  
  if (!badge || !quickViewBody) {
    console.log('Pre-sale badge or quick view body not found');
    return;
  }
  
  // Get user's selected postcode
  const selectedPostcode = getCookie('deliveryPostcode');
  
  if (!selectedPostcode) {
    // No location selected, hide badge
    badge.classList.remove('show');
    badge.style.display = 'none';
    console.log('No postcode selected, hiding pre-sale badge');
    return;
  }
  
  // Determine user's location (same logic as carousel)
  const location = findPostcodeLocation(selectedPostcode);
  console.log(`User location determined: ${location} for postcode: ${selectedPostcode}`);
  
  // Check if pre-sale is enabled for this specific location
  let isPreSaleEnabledForLocation = false;
  
  switch(location) {
    case 'Brisbane':
      isPreSaleEnabledForLocation = quickViewBody.getAttribute('data-pre-sale-brisbane') === 'true';
      break;
    case 'Melbourne':
      isPreSaleEnabledForLocation = quickViewBody.getAttribute('data-pre-sale-melbourne') === 'true';
      break;
    case 'Sydney':
      isPreSaleEnabledForLocation = quickViewBody.getAttribute('data-pre-sale-sydney') === 'true';
      break;
    case 'RestofAustralia':
      isPreSaleEnabledForLocation = quickViewBody.getAttribute('data-pre-sale-rest-australia') === 'true';
      break;
    default:
      isPreSaleEnabledForLocation = false;
  }
  
  console.log(`Pre-sale enabled for ${location}:`, isPreSaleEnabledForLocation);
  
  // Show/hide badge based on location-specific pre-sale status
  if (isPreSaleEnabledForLocation) {
    badge.classList.add('show');
    badge.style.display = 'inline-block';
    console.log(`Quick view pre-sale badge shown for ${location}`);
  } else {
    badge.classList.remove('show');
    badge.style.display = 'none';
    console.log(`Quick view pre-sale badge hidden for ${location}`);
  }
}

// Helper function to get cookie value
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Helper function to find postcode location (same as carousel)
function findPostcodeLocation(userSelectedPostcode) {
  if (typeof brisbanePostcodes === 'undefined' || 
      typeof melbournePostcodes === 'undefined' || 
      typeof SydneyPostcodes === 'undefined' || 
      typeof RestofAustraliaPostcodes === 'undefined') {
    console.warn('Postcode arrays not found in quick view');
    return "Unknown Location";
  }
  
  var brisbanePostcodesArray = brisbanePostcodes.Postcodes[0].split(',');
  var melbournePostcodesArray = melbournePostcodes.Postcodes[0].split(',');
  var sydneyPostcodesArray = SydneyPostcodes.Postcodes[0].split(',');
  var restOfAustraliaPostcodesArray = RestofAustraliaPostcodes.Postcodes[0].split(',');
  
  function matchesPattern(pattern, postcode) {
    if (pattern.endsWith('*')) {
      let prefix = pattern.slice(0, -1);
      return postcode.startsWith(prefix);
    } else if (pattern.includes(',')) {
      return pattern.split(',').includes(postcode);
    } else {
      return pattern === postcode;
    }
  }
  
  let postcodeStr = userSelectedPostcode.toString();
  
  if (brisbanePostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
    return "Brisbane";
  } else if (melbournePostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
    return "Melbourne";
  } else if (sydneyPostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
    return "Sydney";
  } else if (restOfAustraliaPostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
    return "RestofAustralia";
  } else {
    return "Unknown Location";
  }
}

// Listen for delivery info updates
window.addEventListener('deliveryInfoUpdated', function() {
  console.log('Delivery info updated, updating quick view pre-sale badge');
  setTimeout(updateQuickViewPreSaleBadge, 100);
});

// Listen for popup close events
document.addEventListener('popupClosed', function() {
  console.log('Popup closed, updating quick view pre-sale badge');
  setTimeout(updateQuickViewPreSaleBadge, 100);
});

// =============================================
// QUICK VIEW SLIDER CONTROLS
// =============================================
// Quick View Slider Controls - All devices
document.addEventListener('DOMContentLoaded', function() {
  // Initialize slider when quick view opens
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList && mutation.target.classList.contains('show__modal')) {
        initializeQuickViewSlider();
        // Also update pre-sale badge when quick view opens
        setTimeout(() => {
          updateQuickViewPreSaleBadge();
        }, 200);
      }
    });
  });

  if (quickViewWarpper) {
    observer.observe(quickViewWarpper, { 
      attributes: true, 
      attributeFilter: ['class'] 
    });
  }
});

function initializeQuickViewSlider() {
  setTimeout(() => {
    const slider = document.getElementById('quickview-slider');
    const prevButton = document.querySelector('.quickview-prev');
    const nextButton = document.querySelector('.quickview-next');
    const dots = document.querySelectorAll('.quickview-slider-dot');
    
    if (!slider || !prevButton || !nextButton) return;

    const slides = slider.querySelectorAll('.slider__slide');
    let currentSlide = 0;
    let isScrolling = false;
    let scrollEndTimer;

    function updateSlider(index, fromScroll = false) {
      if (index < 0 || index >= slides.length) return;
      
      currentSlide = index;
      
      if (!fromScroll) {
        const slideWidth = slides[0].offsetWidth;
        slider.scrollTo({
          left: slideWidth * currentSlide,
          behavior: 'smooth'
        });
      }

      // Update dots immediately
      dots.forEach((dot, i) => {
        if (i === currentSlide) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });

      // Update button states
      prevButton.disabled = currentSlide === 0;
      nextButton.disabled = currentSlide === slides.length - 1;
    }

    // Arrow button clicks
    prevButton.addEventListener('click', () => {
      isScrolling = true;
      updateSlider(currentSlide - 1);
      setTimeout(() => { isScrolling = false; }, 500);
    });

    nextButton.addEventListener('click', () => {
      isScrolling = true;
      updateSlider(currentSlide + 1);
      setTimeout(() => { isScrolling = false; }, 500);
    });

    // Dot clicks
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        isScrolling = true;
        updateSlider(index);
        setTimeout(() => { isScrolling = false; }, 500);
      });
    });

    // Improved scroll detection with immediate feedback
    let ticking = false;
    function updateScrollPosition() {
      if (!ticking && !isScrolling) {
        window.requestAnimationFrame(function() {
          const slideWidth = slides[0].offsetWidth;
          const newIndex = Math.round(slider.scrollLeft / slideWidth);
          
          if (newIndex !== currentSlide && newIndex >= 0 && newIndex < slides.length) {
            updateSlider(newIndex, true);
          }
          
          ticking = false;
        });
        ticking = true;
      }
    }

    // Listen to scroll events with immediate update
    slider.addEventListener('scroll', () => {
      updateScrollPosition();
      
      // Clear the previous timer
      clearTimeout(scrollEndTimer);
      
      // Set a new timer to detect when scrolling has stopped
      scrollEndTimer = setTimeout(() => {
        // Final position check when scrolling stops
        const slideWidth = slides[0].offsetWidth;
        const finalIndex = Math.round(slider.scrollLeft / slideWidth);
        if (finalIndex !== currentSlide && finalIndex >= 0 && finalIndex < slides.length) {
          updateSlider(finalIndex, true);
        }
      }, 150);
    });

    // Touch events for better mobile response
    let touchStartX = 0;
    let touchEndX = 0;
    
    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    slider.addEventListener('touchmove', () => {
      // Update position during touch move for immediate visual feedback
      updateScrollPosition();
    }, { passive: true });

    slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipeGesture();
    }, { passive: true });

    function handleSwipeGesture() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0 && currentSlide < slides.length - 1) {
          // Swiped left - go to next
          updateSlider(currentSlide + 1);
        } else if (diff < 0 && currentSlide > 0) {
          // Swiped right - go to previous
          updateSlider(currentSlide - 1);
        }
      }
    }

    // Initialize button states
    updateSlider(0);

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Maintain current slide position after resize
        const slideWidth = slides[0].offsetWidth;
        slider.scrollTo({
          left: slideWidth * currentSlide,
          behavior: 'auto'
        });
      }, 250);
    });
  }, 100);
}

// =============================================
// QUICK VIEW TRIGGERS FROM IMAGE/TITLE CLICKS
// =============================================
(function() {
  // Handle clicks on image overlay and title triggers
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.product__card--quickview-trigger, .product__title--quickview-trigger');
    
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      
      const productHandle = trigger.getAttribute('data-product-handle');
      
      if (productHandle) {
        // Add UNIQUE loading class instead of generic 'loading'
        trigger.classList.add('qv-loading');
        
        // Create a temporary quick-view-modal element to use existing functionality
        const tempQuickViewModal = document.createElement('quick-view-modal');
        const tempButton = document.createElement('button');
        tempButton.setAttribute('data-product-handle', productHandle);
        tempButton.setAttribute('aria-haspopup', 'dialog');
        tempQuickViewModal.appendChild(tempButton);
        
        // Trigger the quick view using the existing system
        tempQuickViewModal.onClickQuickViewModal().finally(() => {
          // Remove UNIQUE loading class after modal opens
          trigger.classList.remove('qv-loading');
        });
      }
    }
  });
})();

// Quick View Description Read More functionality
document.addEventListener('DOMContentLoaded', function() {
  initializeQuickViewDescription();
});

// Also initialize when quick view opens
const quickViewWrapper = document.getElementById('quickViewWrapper');
if (quickViewWrapper) {
  const descObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (quickViewWrapper.classList.contains('show__modal')) {
          setTimeout(initializeQuickViewDescription, 100);
        }
      }
    });
  });
  
  descObserver.observe(quickViewWrapper, {
    attributes: true,
    attributeFilter: ['class']
  });
}

function initializeQuickViewDescription() {
  const description = document.getElementById('quickview-description');
  const readMoreBtn = document.getElementById('quickview-read-more');
  const wrapper = document.querySelector('.quickview__description-wrapper');
  
  if (!description || !readMoreBtn) return;
  
  // Check if description has paragraph tags
  const paragraphs = description.querySelectorAll('p');
  const hasParagraphs = paragraphs.length > 0;
  
  let needsReadMore = false;
  
  if (hasParagraphs) {
    description.classList.add('has-paragraphs');
    description.classList.remove('no-paragraphs');
    
    // Calculate total text length and line count
    let totalText = '';
    let significantParagraphs = 0;
    
    paragraphs.forEach(p => {
      const text = p.textContent.trim();
      if (text.length > 0) {
        totalText += text + ' ';
        significantParagraphs++;
      }
    });
    
    // Check if first paragraph alone is substantial (more than ~150 characters)
    const firstParagraphText = paragraphs[0].textContent.trim();
    const isFirstParagraphSubstantial = firstParagraphText.length > 150;
    
    // Show "more" if:
    // 1. There are multiple paragraphs AND first paragraph is substantial
    // 2. OR total content is long (more than 300 characters)
    // 3. OR there are more than 2 paragraphs regardless of length
    needsReadMore = (significantParagraphs > 1 && isFirstParagraphSubstantial) || 
                    totalText.length > 300 || 
                    significantParagraphs > 2;
    
  } else {
    // If plain text, check if overflows 3 lines
    description.classList.add('no-paragraphs');
    description.classList.remove('has-paragraphs');
    
    // Temporarily apply line clamp to check overflow
    const originalHeight = description.scrollHeight;
    const clampedHeight = description.clientHeight;
    needsReadMore = originalHeight > clampedHeight;
  }
  
  if (!needsReadMore) {
    wrapper.classList.add('no-overflow');
    readMoreBtn.style.display = 'none';
    description.classList.add('expanded'); // Show all content
    return;
  }
  
  // Reset state
  description.classList.remove('expanded');
  readMoreBtn.textContent = '...more';
  readMoreBtn.classList.remove('hidden');
  readMoreBtn.style.display = 'inline-block';
  wrapper.classList.remove('no-overflow');
  
  // Remove old event listeners by cloning
  const newReadMoreBtn = readMoreBtn.cloneNode(true);
  readMoreBtn.parentNode.replaceChild(newReadMoreBtn, readMoreBtn);
  
  // Add fresh event listener
  newReadMoreBtn.addEventListener('click', function() {
    const isExpanded = description.classList.contains('expanded');
    
    if (isExpanded) {
      description.classList.remove('expanded');
      newReadMoreBtn.textContent = '...more';
      
      // Scroll back to description top smoothly
      description.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else {
      description.classList.add('expanded');
      newReadMoreBtn.textContent = 'less';
    }
  });
}